(() => {
  const DESIGN_CHECK_VARIANT = 63964067234169;
  let running = false;
  let queued = false;

  const root = () => window.Shopify?.routes?.root || '/';

  async function normalizeDesignCheck() {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    try {
      const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const lines = cart.items.filter((item) => Number(item.variant_id || item.id) === DESIGN_CHECK_VARIANT);
      const required = cart.items.some((item) => item.properties?._rista_design_id && item.properties?._rista_requires_design_check === 'true');
      if (required && !lines.length) {
        const addResponse = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: DESIGN_CHECK_VARIANT, quantity: 1, properties: { _rista_order_service: 'Profi Design-Check', 'Gilt für': 'Gesamte Bestellung' } }] }),
        });
        if (!addResponse.ok) return;
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'rista-design-check-guard' } }));
        if (window.location.pathname === `${root()}cart`) window.location.reload();
        return;
      }
      if (!lines.length || (lines.length === 1 && Number(lines[0].quantity) === 1)) return;

      const updates = {};
      lines.forEach((item, index) => { updates[item.key] = index === 0 ? 1 : 0; });
      const updateResponse = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!updateResponse.ok) return;
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { source: 'rista-design-check-guard' },
      }));
      if (window.location.pathname === `${root()}cart`) window.location.reload();
    } catch (error) {
      console.error('[RISTA] Der Profi Design-Check konnte nicht auf Menge 1 begrenzt werden.', error);
    } finally {
      running = false;
      if (queued) {
        queued = false;
        window.setTimeout(normalizeDesignCheck, 100);
      }
    }
  }

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.source !== 'rista-design-check-guard') window.setTimeout(normalizeDesignCheck, 100);
  });
  window.addEventListener('pageshow', () => {
    if (window.location.pathname === `${root()}cart`) void normalizeDesignCheck();
  });
})();
